import { IProject } from '@common/interfaces/project';
import { EntityState, EntityStore, EntityUIStore, ActiveState } from '@datorama/akita';
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { Injectable } from '@angular/core';
import { Topics } from '@common/interfaces/topics';


export type JProjectUI = {
  id: string;
  newsBadge: string[];
  item: string;
  itemView: { [item: string]: string }
}

export interface ProjectState extends EntityState<IProject, string>, ActiveState<string> { };
export interface ProjectUIState extends EntityState<JProjectUI, string>, ActiveState<string> { };

@Injectable({ providedIn: 'root' })
@PersistedStoreConfig({ name: Topics.PROJECTS, realtimeEntity: 'Project', persistUiStore: true, persistence: 'external', resettable: true })
export class ProjectStore extends EntityStore<ProjectState> {

  ui: EntityUIStore<ProjectUIState>;

  constructor() {
    super();
    this.createUIStore().setInitialEntityState({ newsBadge: [] });
  }
}
